import { render } from "./TourBookingSubmission.vue?vue&type=template&id=78f2c221"
import script from "./TourBookingSubmission.vue?vue&type=script&lang=js"
export * from "./TourBookingSubmission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__